import "./styles.scss";
import { useIntl } from "react-intl";
import { formatDateOnlyString } from "../../../../utils/dateUtils";
export interface IInfoProps {
  chassis: string;
  model: string;
  licensePlate: string;
  contractNumber: string;
  contractType: string;
  accountName: string;
  contractStatus: string;
  startAt?: string;
  endAt?: string;
  activationDate?: string;
  odometer: string;
  hourMeter: string;
  hiddenFields?: string[];
}

const InfoPlanEssential = ({
  chassis,
  model,
  licensePlate,
  contractNumber,
  contractType,
  accountName,
  contractStatus,
  startAt,
  endAt,
  activationDate,
  odometer,
  hourMeter,
  hiddenFields,
}: IInfoProps) => {
  const intl = useIntl();

  return (
  <section className="margin-bottom-20 contract-details-info">
    <div className="contract-details-info__grid">
      {hiddenFields?.includes("chassis") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.chassis" })}:</span>
        <span className="contract-details-info__value truncate">{chassis}</span>
      </div>}
      
      {hiddenFields?.includes("contractStatus") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractStatus" })}:</span>
        <span className="contract-details-info__value truncate">{contractStatus}</span>
      </div>}
      
      {hiddenFields?.includes("contractType") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractType" })}:</span>
        <span className="contract-details-info__value truncate">{contractType}</span>
      </div>}

      {hiddenFields?.includes("contractNumber") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.contractNumber" })}:</span>
        <span className="contract-details-info__value truncate">{contractNumber}</span>
      </div>}

      {!hiddenFields?.includes("odometer") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{odometer ? intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.odometer" }) : hourMeter ? intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.hourmeter" }) : ""}</span>
        <span className="contract-details-info__value truncate">{odometer ? `${Number(odometer).toLocaleString(intl.locale)} km` : hourMeter ? `${Number(hourMeter).toLocaleString(intl.locale)} h` : ""}</span>
      </div>}

      {hiddenFields?.includes("licensePlate") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.licensePlate" })}:</span>
        <span className="contract-details-info__value truncate">{licensePlate}</span>
      </div>}

      {hiddenFields?.includes("model") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.model" })}:</span>
        <span className="contract-details-info__value truncate">{model}</span>
      </div>}

      {hiddenFields?.includes("startAt") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.warrantyStartDate" })}:</span>
        <span className="contract-details-info__value truncate">{startAt ? formatDateOnlyString(startAt) : "—"}</span>
      </div>}

      {hiddenFields?.includes("endAt") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.validity" })}:</span>
        <span className="contract-details-info__value truncate">{startAt && endAt ? `${formatDateOnlyString(startAt)} - ${formatDateOnlyString(endAt)}` : "—"}</span>
      </div>}

      {hiddenFields?.includes("activationDate") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.activationDate" })}:</span>
        <span className="contract-details-info__value truncate">{activationDate ? formatDateOnlyString(activationDate) : "—"}</span>
      </div>}

      {hiddenFields?.includes("accountName") ? null : <div className="contract-details-info__row">
        <span className="contract-details-info__label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.info.accountName" })}:</span>
        <span className="contract-details-info__value truncate">{accountName}</span>
      </div>}
    </div>
  </section>
)
};

export default InfoPlanEssential;
